import axios from 'axios'
const PS_BASEURL = '/'
export default {
    get(page) {
        return axios.get(`${PS_BASEURL}wp-json/wp/v2/programacao-semanal`, { params: { per_page: 50, page: page || 1 } })
    }
}